import { Box, Container } from "@mui/material";
import SectionTitle from "../components/SectionTitle";

const ServicesPage = () => (
  <Box sx={{ pt: 14, pb: 10, minHeight: "80vh", backgroundColor: "#f5f0e8" }}>
    <Container maxWidth="lg">
      <SectionTitle
        overline="Nos Prestations"
        title="Tous Nos Services"
        subtitle="Découvrez l'ensemble de nos offres premium conçues pour prendre soin de vos vêtements et textiles."
      />
    </Container>
  </Box>
);

export default ServicesPage;